import AboutBoa from './AboutBoa'


export default AboutBoa
